import { Component } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/shared/service/data.service';

export interface PromptModel {
  title:string;
  question:string;
}

@Component({
  selector: 'prompt',
  templateUrl: './add-row.component.html',
  // template: `

  // `,
  styleUrls: ['./add-row.component.scss'],
  // styles: [`

  // `]
})
export class AddRowComponent extends SimpleModalComponent<PromptModel, string> implements PromptModel {
  title: string = '';
  question: string = '';
  message: string = '';

  error:string = '';
  errorFaculty:string = '';

  public form: FormGroup = this.formBuilder.group({});

  constructor(
    private formBuilder: FormBuilder,
    public dataService: DataService,
    ) {
    super();
    this.createAccountForm();
  }
  apply() {

    this.result = JSON.stringify(this.form.value);
    console.log('form value', this.form.value)
    this.close();
  }
  onAdd(event:any){}
  createAccountForm() {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
    })
  }

  checkForSimilarFaculty(event:any){
    const inputValue= event.srcElement.value;
    if(this.dataService.departments?.find((r:any) => r.name === inputValue)){
      this.errorFaculty = 'Bunday fakultet kirizilgan';
    }else{this.errorFaculty = '';}
  }
}
